import { useCallback, useEffect, useRef } from 'react'

// Only a physical pointer in the price pane can choose an alert level. Linked
// crosshairs and volume-pane prices must never become order/alert inputs.
export function usePriceAlertCrosshair({ chartRef, seriesRef, containerRef, ready, enabled, symbol, timeframe, onCreate }) {
  const hovered = useRef(null)
  useEffect(() => {
    hovered.current = null
    const chart = chartRef.current, container = containerRef.current
    if (!enabled || !chart || !container) return undefined
    const clear = () => { hovered.current = null }
    const move = event => {
      if (!event.sourceEvent) return
      clear()
      const point = event.point
      if (!point || point.x < 0 || point.y < 0 || (event.paneIndex != null && event.paneIndex !== 0)) return
      const series = seriesRef.current
      const price = series?.coordinateToPrice(point.y)
      const precision = series?.options?.().priceFormat?.precision ?? 2
      if (Number.isFinite(price) && price > 0) hovered.current = { price: Number(price.toFixed(Math.max(0, Math.min(8, precision)))), symbol, timeframe }
    }
    chart.subscribeCrosshairMove(move)
    container.addEventListener('pointerleave', clear)
    window.addEventListener('blur', clear)
    return () => {
      clear()
      chart.unsubscribeCrosshairMove(move)
      container.removeEventListener('pointerleave', clear)
      window.removeEventListener('blur', clear)
    }
  }, [chartRef, seriesRef, containerRef, ready, enabled, symbol, timeframe])
  return useCallback(() => {
    const point = hovered.current
    if (!enabled || !onCreate || !point || point.symbol !== symbol || point.timeframe !== timeframe || containerRef.current?.closest('[inert]')) return false
    onCreate(point.price)
    return true
  }, [enabled, onCreate, symbol, timeframe, containerRef])
}
